var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.role.name === 'Student')?_c('v-list',{staticClass:"py-0"},[_c('StudentExam'),_c('StudentUniform')],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }